<script setup lang="ts">
import type { ExtendedBlogPostProps } from '~/types/elementsUi'
import type { TailwindColor } from '#shared/types/elementsUi'

interface BlogPostsSectionProps {
  title?: string
  description?: string
  backgroundColor?: TailwindColor
  blogPosts: ExtendedBlogPostProps[]
}

const props = withDefaults(defineProps<BlogPostsSectionProps>(), {
  title: undefined,
  description: undefined,
  backgroundColor: undefined
})
</script>

<template>
  <VSection
    v-if="blogPosts.length > 0"
    :title
    :description
    :ui="{ section: backgroundColor && `bg-${backgroundColor}` }"
  >
    <template #content>
      <VBlogPosts :blog-posts="blogPosts" />
    </template>
  </VSection>
</template>

<style scoped></style>
